<template>
  <v-container id="home_menu" fluid tag="section" class="elegant-container">
    <v-alert
      icon="mdi-shield-lock-outline"
      prominent
      text
      type="info"
      border="left"
      colored-border
      elevation="2"
      class="elegant-user-card"
    >
      <v-row no-gutters align="center">
        <v-col cols="12" md="6">
          <div class="user-info-section">
            <h2 class="user-title">ผู้ใช้งานระบบ : {{ user.user_ID }}</h2>
          </div>
          <div>
            <h3 class="user-name">
              ชื่อผู้ใช้งาน : {{ user.user_firstname }}
              {{ user.user_lastname || "" }}
            </h3>
          </div>
          <h3 class="user-status">สถานะ : {{ user.user_status }}</h3>
        </v-col>
        <v-col cols="12" md="6">
          <div align="right" class="action-buttons">
            <v-btn
              class="elegant-btn edit-btn"
              fab
              dark
              color="warning"
              outlined
              @click.native="userUpdate()"
              title="แก้ไขข้อมูลส่วนตัว"
            >
              <v-icon dark>mdi-pencil</v-icon>
            </v-btn>
            <v-btn
              v-if="user.userauthorityAdmin === '1'"
              class="elegant-btn calendar-btn"
              fab
              dark
              color="warning"
              outlined
              @click="endCalendar()"
              title="ยกเลิกกำหนดการระบบทั้งหมด"
            >
              <v-icon dark>mdi-calendar-remove</v-icon>
            </v-btn>
            <v-btn
              v-if="user.userauthorityAdmin === '1'"
              class="elegant-btn update-btn"
              fab
              dark
              color="warning"
              outlined
              @click="clearUpdate()"
              title="รีเซ็ตอัปเดต"
            >
              <v-icon dark>mdi-update</v-icon>
            </v-btn>
            <v-btn
              v-if="user.userauthorityAdmin === '1'"
              class="elegant-btn admin-btn"
              fab
              dark
              color="warning"
              outlined
              to="/admin/userAdmin"
              title="จัดการผู้ใช้ Admin"
            >
              <v-icon dark>mdi-account-convert</v-icon>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-alert>

    <v-row no-gutters class="mb-4">
      <v-col cols="12" md="12" v-if="user.userauthorityAssitantTeach === '1'">
        <AlertAssistant_teacher />
      </v-col>
      <v-col cols="12" md="12" v-if="user.userauthority_govem !== '1'">
        <AlertAssistant_teacher2 />
        <AlertAssistant_teacher3_licence />
      </v-col>
    </v-row>

    <v-card class="elegant-main-card">
      <div class="d-flex flex-column flex-md-row">
        <v-tabs
          v-model="activeTab"
          :vertical="$vuetify.breakpoint.mdAndUp"
          class="elegant-tabs-menu"
          active-class="active-tab"
          background-color="grey lighten-5"
          color="teal darken-2"
          show-arrows
        >
          <v-tab
            v-for="tab in availableTabs"
            :key="tab.id"
            class="justify-start tab-item"
          >
            <v-icon left class="mr-2" :color="tab.color">{{ tab.icon }}</v-icon>
            <span class="tab-title">{{ tab.title }}</span>
          </v-tab>
        </v-tabs>

        <v-tabs-items
          v-model="activeTab"
          class="flex-grow-1 bg-transparent elegant-tab-content"
        >
          <v-tab-item
            v-for="tab in availableTabs"
            :key="tab.id"
            class="pa-4 pa-md-6"
          >
            <!-- ========================================== -->
            <!-- TAB: ข้อมูลพื้นฐาน -->
            <!-- ========================================== -->
            <div v-if="tab.id === 'basic'">
              <v-alert
                text
                color="teal"
                icon="mdi-database"
                border="left"
                class="mb-4 section-header teal-header"
              >
                <h2 class="section-title">ข้อมูลพื้นฐานระบบ</h2>
              </v-alert>

              <v-row>
                <v-col
                  cols="12"
                  md="4"
                  v-if="
                    user.userauthorityAdmin === '1' ||
                      user.userauthority_govem === '1'
                  "
                >
                  <v-card tile outlined class="elegant-section-card">
                    <v-toolbar
                      color="teal darken-1"
                      dark
                      class="section-toolbar"
                      dense
                    >
                      <v-toolbar-title class="toolbar-title">
                        <v-icon left small>mdi-office-building</v-icon>
                        ข้อมูลสถานศึกษา
                      </v-toolbar-title>
                    </v-toolbar>
                    <v-list class="elegant-list">
                      <v-list-item
                        v-for="(item, i) in college_items"
                        :key="i"
                        :to="item.to"
                        class="elegant-list-item"
                      >
                        <v-list-item-icon>
                          <v-icon
                            v-text="item.icon"
                            class="list-icon"
                            color="teal darken-1"
                          ></v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title
                            v-text="item.text"
                            class="list-title"
                          ></v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>

                <v-col
                  cols="12"
                  md="4"
                  v-if="
                    user.userauthorityAdmin === '1' ||
                      user.userauthority_govem === '1'
                  "
                >
                  <v-card tile outlined class="elegant-section-card">
                    <v-toolbar
                      color="teal darken-1"
                      dark
                      class="section-toolbar"
                      dense
                    >
                      <v-toolbar-title class="toolbar-title">
                        <v-icon left small>mdi-account-cog</v-icon>
                        ผู้ใช้งานระบบ
                      </v-toolbar-title>
                    </v-toolbar>
                    <v-list class="elegant-list">
                      <v-list-item
                        v-for="(item, i) in user_system_items"
                        :key="i"
                        :to="item.to"
                        class="elegant-list-item"
                      >
                        <v-list-item-icon>
                          <v-icon
                            v-text="item.icon"
                            class="list-icon"
                            color="teal darken-1"
                          ></v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title
                            v-text="item.text"
                            class="list-title"
                          ></v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>

                <v-col
                  cols="12"
                  md="4"
                  v-if="
                    user.userauthorityAdmin === '1' ||
                      user.userauthority_govem === '1'
                  "
                >
                  <v-card tile outlined class="elegant-section-card">
                    <v-toolbar
                      color="teal darken-1"
                      dark
                      class="section-toolbar"
                      dense
                    >
                      <v-toolbar-title class="toolbar-title">
                        <v-icon left small>mdi-account-details</v-icon>
                        ข้อมูลงานบุคคล
                      </v-toolbar-title>
                    </v-toolbar>
                    <v-list class="elegant-list">
                      <v-list-item
                        v-for="(item, i) in filteredUserItems"
                        :key="i"
                        :to="item.to"
                        class="elegant-list-item"
                      >
                        <v-list-item-icon>
                          <v-icon
                            v-text="item.icon"
                            class="list-icon"
                            color="teal darken-1"
                          ></v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title
                            v-text="item.text"
                            class="list-title"
                          ></v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>

                <v-col cols="12" md="12" v-if="user.userauthorityAdmin === '1'">
                  <v-card tile outlined class="elegant-section-card">
                    <v-toolbar
                      color="teal darken-3"
                      dark
                      class="section-toolbar"
                      dense
                    >
                      <v-toolbar-title class="toolbar-title">
                        <v-icon left small>mdi-source-branch</v-icon>
                        สาขาวิชา
                      </v-toolbar-title>
                    </v-toolbar>
                    <v-row class="ma-0">
                      <v-col
                        cols="12"
                        md="6"
                        lg="4"
                        v-for="(item, i) in about_brach"
                        :key="i"
                        class="pa-1"
                      >
                        <v-list class="elegant-list py-0">
                          <v-list-item :to="item.to" class="elegant-list-item">
                            <v-list-item-icon>
                              <v-icon
                                v-text="item.icon"
                                class="list-icon"
                                color="teal darken-3"
                              ></v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title
                                v-text="item.text"
                                class="list-title"
                              ></v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </div>

            <!-- ========================================== -->
            <!-- TAB: งานอัตรากำลัง -->
            <!-- ========================================== -->
            <div v-if="tab.id === 'manpower'">
              <v-alert
                text
                color="blue darken-1"
                icon="mdi-account-group"
                border="left"
                class="mb-4 section-header blue-header"
              >
                <h2 class="section-title">งานอัตรากำลัง</h2>
              </v-alert>

              <v-row>
                <v-col cols="12" md="6">
                  <v-card tile outlined class="elegant-section-card">
                    <v-toolbar
                      color="blue darken-1"
                      dark
                      class="section-toolbar"
                      dense
                    >
                      <v-toolbar-title class="toolbar-title">
                        <v-icon left small>mdi-domain</v-icon>
                        รายงานสถานศึกษา
                      </v-toolbar-title>
                    </v-toolbar>
                    <v-list class="elegant-list">
                      <v-list-item
                        v-for="(item, i) in human_items"
                        :key="i"
                        :to="item.to"
                        class="elegant-list-item"
                      >
                        <v-list-item-icon>
                          <v-icon
                            v-text="item.icon"
                            class="list-icon"
                            color="blue darken-1"
                          ></v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title
                            v-text="item.text"
                            class="list-title"
                          ></v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>

                <v-col cols="12" md="6">
                  <v-card tile outlined class="elegant-section-card">
                    <v-toolbar
                      color="blue darken-1"
                      dark
                      class="section-toolbar"
                      dense
                    >
                      <v-toolbar-title class="toolbar-title">
                        <v-icon left small>mdi-account-switch</v-icon>
                        พิจารณาย้าย
                      </v-toolbar-title>
                    </v-toolbar>
                    <v-list class="elegant-list">
                      <v-list-item
                        v-for="(item, i) in manpower_move"
                        :key="i"
                        :to="item.to"
                        class="elegant-list-item"
                      >
                        <v-list-item-icon>
                          <v-icon
                            v-text="item.icon"
                            class="list-icon"
                            color="blue darken-1"
                          ></v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title
                            v-text="item.text"
                            class="list-title"
                          ></v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>

                <v-col cols="12">
                  <v-card tile outlined class="elegant-section-card mt-2">
                    <v-toolbar
                      color="blue darken-3"
                      dark
                      class="section-toolbar"
                      dense
                    >
                      <v-toolbar-title class="toolbar-title">
                        <v-icon left small>mdi-clipboard-text-search</v-icon>
                        งานสำรวจสาขาวิชาตำแหน่งว่าง
                      </v-toolbar-title>
                    </v-toolbar>
                    <v-row class="ma-0">
                      <v-col
                        cols="12"
                        md="6"
                        lg="3"
                        v-for="(item, i) in humanreport_items"
                        :key="i"
                        class="pa-1"
                      >
                        <v-list class="elegant-list py-0">
                          <v-list-item :to="item.to" class="elegant-list-item">
                            <v-list-item-icon>
                              <v-icon
                                v-text="item.icon"
                                class="list-icon"
                                color="blue darken-3"
                              ></v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title
                                v-text="item.text"
                                class="list-title"
                              ></v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </div>

            <!-- ========================================== -->
            <!-- TAB: ย้ายข้าราชการ/บริหาร -->
            <!-- ========================================== -->
            <div v-if="tab.id === 'transfer'">
              <template v-if="user.userauthorityMoveTeach === '1'">
                <v-alert
                  text
                  color="red darken-1"
                  icon="mdi-account-switch"
                  border="left"
                  class="mb-4 mt-2 section-header red-header"
                >
                  <h2 class="section-title">
                    ระบบการย้าย
                    <v-chip
                      small
                      color="white"
                      text-color="red darken-1"
                      class="ml-2 font-weight-bold"
                      >บุคลากร 38 ค.(2)</v-chip
                    >
                  </h2>
                </v-alert>
                <v-row>
                  <v-col cols="12">
                    <v-card tile outlined class="elegant-section-card">
                      <v-row class="ma-0">
                        <v-col
                          cols="12"
                          md="4"
                          v-for="(item, i) in movement38_items"
                          :key="i"
                          class="pa-1"
                        >
                          <v-list class="elegant-list py-0">
                            <v-list-item
                              :to="item.to"
                              class="elegant-list-item"
                            >
                              <v-list-item-icon>
                                <v-icon
                                  v-text="item.icon"
                                  class="list-icon"
                                  color="red darken-1"
                                ></v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title
                                  v-text="item.text"
                                  class="list-title"
                                ></v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>

                <v-alert
                  text
                  color="pink darken-1"
                  icon="mdi-teach"
                  border="left"
                  class="mb-4 mt-6 section-header pink-header"
                >
                  <h2 class="section-title">
                    ย้าย
                    <v-chip
                      small
                      color="white"
                      text-color="pink darken-1"
                      class="ml-2 font-weight-bold"
                      >สายการสอน</v-chip
                    >
                  </h2>
                </v-alert>
                <v-row>
                  <v-col cols="12" md="4">
                    <v-card tile outlined class="elegant-section-card h-100">
                      <v-toolbar
                        color="pink darken-1"
                        dark
                        class="section-toolbar"
                        dense
                      >
                        <v-toolbar-title class="toolbar-title">
                          <v-icon left small>mdi-transfer</v-icon>
                          ระบบการย้ายสายการสอน
                        </v-toolbar-title>
                      </v-toolbar>
                      <v-list class="elegant-list">
                        <v-list-item
                          v-for="(item, i) in movement_items"
                          :key="i"
                          :to="item.to"
                          class="elegant-list-item"
                        >
                          <v-list-item-icon>
                            <v-icon
                              v-text="item.icon"
                              class="list-icon"
                              color="pink darken-1"
                            ></v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title
                              v-text="item.text"
                              class="list-title"
                            ></v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-card tile outlined class="elegant-section-card mb-4">
                      <v-toolbar
                        color="pink darken-1"
                        dark
                        class="section-toolbar"
                        dense
                      >
                        <v-toolbar-title class="toolbar-title">
                          <v-icon left small>mdi-list-status</v-icon>
                          เงื่อนไขสาขาวิชา
                        </v-toolbar-title>
                      </v-toolbar>
                      <v-list class="elegant-list">
                        <v-list-item
                          v-for="(item, i) in condition_items"
                          :key="i"
                          :to="item.to"
                          class="elegant-list-item"
                        >
                          <v-list-item-icon>
                            <v-icon
                              v-text="item.icon"
                              class="list-icon"
                              color="pink darken-1"
                            ></v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title
                              v-text="item.text"
                              class="list-title"
                            ></v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-card>
                    <v-card tile outlined class="elegant-section-card">
                      <v-toolbar
                        color="pink darken-3"
                        dark
                        class="section-toolbar"
                        dense
                      >
                        <v-toolbar-title class="toolbar-title">
                          <v-icon left small>mdi-account-tie-voice</v-icon>
                          คณะกรรมการ สอจ.
                        </v-toolbar-title>
                      </v-toolbar>
                      <v-list class="elegant-list">
                        <v-list-item
                          v-for="(item, i) in commiteevecpro"
                          :key="i"
                          :to="item.to"
                          class="elegant-list-item"
                        >
                          <v-list-item-icon>
                            <v-icon
                              v-text="item.icon"
                              class="list-icon"
                              color="pink darken-3"
                            ></v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title
                              v-text="item.text"
                              class="list-title"
                            ></v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-card tile outlined class="elegant-section-card">
                      <v-toolbar
                        color="pink darken-1"
                        dark
                        class="section-toolbar"
                        dense
                      >
                        <v-toolbar-title class="toolbar-title">
                          <v-icon left small>mdi-book-open</v-icon>
                          หนังสือราชการ
                        </v-toolbar-title>
                      </v-toolbar>
                      <v-list class="elegant-list">
                        <v-list-item
                          v-for="(item, i) in official_book"
                          :key="i"
                          :to="item.to"
                          class="elegant-list-item"
                        >
                          <v-list-item-icon>
                            <v-icon
                              v-text="item.icon"
                              class="list-icon"
                              color="pink darken-1"
                            ></v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title
                              v-text="item.text"
                              class="list-title"
                            ></v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-card>
                  </v-col>
                </v-row>
              </template>

              <template v-if="user.userauthorityMoveManage === '1'">
                <v-alert
                  text
                  color="deep-purple"
                  icon="mdi-account-tie"
                  border="left"
                  class="mb-4 mt-6 section-header purple-header"
                >
                  <h2 class="section-title">
                    ย้าย
                    <v-chip
                      small
                      color="white"
                      text-color="deep-purple"
                      class="ml-2 font-weight-bold"
                      >สายงานบริหารสถานศึกษา</v-chip
                    >
                  </h2>
                </v-alert>
                <v-row>
                  <v-col cols="12">
                    <v-card tile outlined class="elegant-section-card">
                      <v-row class="ma-0">
                        <v-col
                          cols="12"
                          md="6"
                          lg="4"
                          v-for="(item, i) in movement_manage_items"
                          :key="i"
                          class="pa-1"
                        >
                          <v-list class="elegant-list py-0">
                            <v-list-item
                              :to="item.to"
                              class="elegant-list-item"
                            >
                              <v-list-item-icon>
                                <v-icon
                                  v-text="item.icon"
                                  class="list-icon"
                                  color="deep-purple"
                                ></v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title
                                  v-text="item.text"
                                  class="list-title"
                                ></v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </template>
            </div>

            <!-- ========================================== -->
            <!-- TAB: พนักงานราชการ -->
            <!-- ========================================== -->
            <div v-if="tab.id === 'govem'">
              <v-alert
                text
                color="indigo"
                icon="mdi-account-hard-hat"
                border="left"
                class="mb-4 section-header indigo-header"
              >
                <h2 class="section-title">
                  กรอบอัตรากำลัง
                  <v-chip
                    small
                    color="white"
                    text-color="indigo"
                    class="ml-2 font-weight-bold"
                    >พนักงานราชการ</v-chip
                  >
                </h2>
              </v-alert>

              <v-row>
                <v-col cols="12" md="4">
                  <v-card tile outlined class="elegant-section-card">
                    <v-toolbar
                      color="indigo"
                      dark
                      class="section-toolbar"
                      dense
                    >
                      <v-toolbar-title class="toolbar-title"
                        ><v-icon left small>mdi-domain</v-icon>
                        บริหารงานกรอบอัตรา</v-toolbar-title
                      >
                    </v-toolbar>
                    <v-list class="elegant-list">
                      <v-list-item
                        v-for="(item, i) in movement_govem_manpoweritems"
                        :key="i"
                        :to="item.to"
                        class="elegant-list-item"
                      >
                        <v-list-item-icon
                          ><v-icon
                            v-text="item.icon"
                            class="list-icon"
                            color="indigo"
                          ></v-icon
                        ></v-list-item-icon>
                        <v-list-item-content
                          ><v-list-item-title
                            v-text="item.text"
                            class="list-title"
                          ></v-list-item-title
                        ></v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
                <v-col cols="12" md="4">
                  <v-card tile outlined class="elegant-section-card">
                    <v-toolbar
                      color="indigo"
                      dark
                      class="section-toolbar"
                      dense
                    >
                      <v-toolbar-title class="toolbar-title"
                        ><v-icon left small>mdi-card-account-details</v-icon>
                        ประวัติพนักงานราชการ</v-toolbar-title
                      >
                    </v-toolbar>
                    <v-list class="elegant-list">
                      <v-list-item
                        v-for="(item, i) in govem_manpowerManageitems"
                        :key="i"
                        :to="item.to"
                        class="elegant-list-item"
                      >
                        <v-list-item-icon
                          ><v-icon
                            v-text="item.icon"
                            class="list-icon"
                            color="indigo"
                          ></v-icon
                        ></v-list-item-icon>
                        <v-list-item-content
                          ><v-list-item-title
                            v-text="item.text"
                            class="list-title"
                          ></v-list-item-title
                        ></v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
                <v-col cols="12" md="4">
                  <v-card tile outlined class="elegant-section-card">
                    <v-toolbar
                      color="indigo"
                      dark
                      class="section-toolbar"
                      dense
                    >
                      <v-toolbar-title class="toolbar-title"
                        ><v-icon left small>mdi-cash-multiple</v-icon>
                        รายงานค่าตอบแทน</v-toolbar-title
                      >
                    </v-toolbar>
                    <v-list class="elegant-list">
                      <v-list-item
                        v-for="(item, i) in movement_govem_manpowerSalaryitems"
                        :key="i"
                        :to="item.to"
                        class="elegant-list-item"
                      >
                        <v-list-item-icon
                          ><v-icon
                            v-text="item.icon"
                            class="list-icon"
                            color="indigo"
                          ></v-icon
                        ></v-list-item-icon>
                        <v-list-item-content
                          ><v-list-item-title
                            v-text="item.text"
                            class="list-title"
                          ></v-list-item-title
                        ></v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
              </v-row>

              <v-alert
                text
                color="deep-purple accent-3"
                icon="mdi-swap-horizontal"
                border="left"
                class="mb-4 mt-6 section-header purple-accent-header"
              >
                <h2 class="section-title">
                  ย้าย
                  <v-chip
                    small
                    color="white"
                    text-color="deep-purple accent-3"
                    class="ml-2 font-weight-bold"
                    >พนักงานราชการ</v-chip
                  >
                </h2>
              </v-alert>

              <v-row>
                <v-col cols="12" md="4">
                  <v-card tile outlined class="elegant-section-card">
                    <v-toolbar
                      color="deep-purple accent-3"
                      dark
                      class="section-toolbar"
                      dense
                    >
                      <v-toolbar-title class="toolbar-title"
                        ><v-icon left small>mdi-transfer-right</v-icon>
                        ระบบการย้าย</v-toolbar-title
                      >
                    </v-toolbar>
                    <v-list class="elegant-list">
                      <v-list-item
                        v-for="(item, i) in movement_govem_items"
                        :key="i"
                        :to="item.to"
                        class="elegant-list-item"
                      >
                        <v-list-item-icon
                          ><v-icon
                            v-text="item.icon"
                            class="list-icon"
                            color="deep-purple accent-3"
                          ></v-icon
                        ></v-list-item-icon>
                        <v-list-item-content
                          ><v-list-item-title
                            v-text="item.text"
                            class="list-title"
                          ></v-list-item-title
                        ></v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
                <v-col cols="12" md="4">
                  <v-card tile outlined class="elegant-section-card">
                    <v-toolbar
                      color="deep-purple accent-3"
                      dark
                      class="section-toolbar"
                      dense
                    >
                      <v-toolbar-title class="toolbar-title"
                        ><v-icon left small>mdi-list-status</v-icon>
                        เงื่อนไข/ตำแหน่งว่าง</v-toolbar-title
                      >
                    </v-toolbar>
                    <v-list class="elegant-list">
                      <v-list-item
                        v-for="(item, i) in condition_govem_items"
                        :key="i"
                        :to="item.to"
                        class="elegant-list-item"
                      >
                        <v-list-item-icon
                          ><v-icon
                            v-text="item.icon"
                            class="list-icon"
                            color="deep-purple accent-3"
                          ></v-icon
                        ></v-list-item-icon>
                        <v-list-item-content
                          ><v-list-item-title
                            v-text="item.text"
                            class="list-title"
                          ></v-list-item-title
                        ></v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
                <v-col cols="12" md="4">
                  <v-card tile outlined class="elegant-section-card">
                    <v-toolbar
                      color="deep-purple accent-3"
                      dark
                      class="section-toolbar"
                      dense
                    >
                      <v-toolbar-title class="toolbar-title"
                        ><v-icon left small>mdi-book-open</v-icon>
                        หนังสือราชการ</v-toolbar-title
                      >
                    </v-toolbar>
                    <v-list class="elegant-list">
                      <v-list-item
                        v-for="(item, i) in official_book_govem"
                        :key="i"
                        :to="item.to"
                        class="elegant-list-item"
                      >
                        <v-list-item-icon
                          ><v-icon
                            v-text="item.icon"
                            class="list-icon"
                            color="deep-purple accent-3"
                          ></v-icon
                        ></v-list-item-icon>
                        <v-list-item-content
                          ><v-list-item-title
                            v-text="item.text"
                            class="list-title"
                          ></v-list-item-title
                        ></v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
              </v-row>
            </div>

            <!-- ========================================== -->
            <!-- TAB: คัดเลือกสายบริหาร/ศน. -->
            <!-- ========================================== -->
            <div v-if="tab.id === 'selection'">
              <!-- === รองผู้อำนวยการ === -->
              <v-alert
                text
                color="green darken-1"
                icon="mdi-star-half-full"
                border="left"
                class="mb-4 section-header green-header"
              >
                <h2 class="section-title">
                  คัดเลือก ตำแหน่ง
                  <v-chip
                    small
                    color="white"
                    text-color="green darken-1"
                    class="ml-2 font-weight-bold"
                    >รองผู้อำนวยการวิทยาลัย</v-chip
                  >
                </h2>
              </v-alert>
              <v-row>
                <v-col cols="12" md="6">
                  <v-card tile outlined class="elegant-section-card">
                    <v-toolbar
                      color="green darken-1"
                      dark
                      class="section-toolbar"
                      dense
                    >
                      <v-toolbar-title class="toolbar-title"
                        ><v-icon left small>mdi-clipboard-list</v-icon>
                        ระบบสมัครสอบ (1)</v-toolbar-title
                      >
                    </v-toolbar>
                    <v-list class="elegant-list">
                      <v-list-item
                        v-for="(item, i) in appoint_sedirector"
                        :key="i"
                        :to="item.to"
                        class="elegant-list-item"
                      >
                        <v-list-item-icon
                          ><v-icon
                            v-text="item.icon"
                            class="list-icon"
                            color="green darken-1"
                          ></v-icon
                        ></v-list-item-icon>
                        <v-list-item-content
                          ><v-list-item-title
                            v-text="item.text"
                            class="list-title"
                          ></v-list-item-title
                        ></v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
                <v-col cols="12" md="6">
                  <v-card tile outlined class="elegant-section-card">
                    <v-toolbar
                      color="green darken-1"
                      dark
                      class="section-toolbar"
                      dense
                    >
                      <v-toolbar-title class="toolbar-title"
                        ><v-icon left small>mdi-clipboard-list-outline</v-icon>
                        ระบบสมัครสอบ (2)</v-toolbar-title
                      >
                    </v-toolbar>
                    <v-list class="elegant-list">
                      <v-list-item
                        v-for="(item, i) in appoint_sedirector2"
                        :key="i"
                        :to="item.to"
                        class="elegant-list-item"
                      >
                        <v-list-item-icon
                          ><v-icon
                            v-text="item.icon"
                            class="list-icon"
                            color="green darken-1"
                          ></v-icon
                        ></v-list-item-icon>
                        <v-list-item-content
                          ><v-list-item-title
                            v-text="item.text"
                            class="list-title"
                          ></v-list-item-title
                        ></v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
              </v-row>

              <!-- === ผู้อำนวยการ === -->
              <v-alert
                text
                color="green darken-4"
                icon="mdi-star-circle"
                border="left"
                class="mb-4 mt-6 section-header green-dark-header"
              >
                <h2 class="section-title">
                  คัดเลือก ตำแหน่ง
                  <v-chip
                    small
                    color="white"
                    text-color="green darken-4"
                    class="ml-2 font-weight-bold"
                    >ผู้อำนวยการวิทยาลัย</v-chip
                  >
                </h2>
              </v-alert>
              <v-row>
                <v-col cols="12" md="6">
                  <v-card tile outlined class="elegant-section-card">
                    <v-toolbar
                      color="green darken-4"
                      dark
                      class="section-toolbar"
                      dense
                    >
                      <v-toolbar-title class="toolbar-title"
                        ><v-icon left small>mdi-clipboard-list</v-icon>
                        ระบบสมัครสอบ (1)</v-toolbar-title
                      >
                    </v-toolbar>
                    <v-list class="elegant-list">
                      <v-list-item
                        v-for="(item, i) in appoint_director"
                        :key="i"
                        :to="item.to"
                        class="elegant-list-item"
                      >
                        <v-list-item-icon
                          ><v-icon
                            v-text="item.icon"
                            class="list-icon"
                            color="green darken-4"
                          ></v-icon
                        ></v-list-item-icon>
                        <v-list-item-content
                          ><v-list-item-title
                            v-text="item.text"
                            class="list-title"
                          ></v-list-item-title
                        ></v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
                <v-col cols="12" md="6">
                  <v-card tile outlined class="elegant-section-card">
                    <v-toolbar
                      color="green darken-4"
                      dark
                      class="section-toolbar"
                      dense
                    >
                      <v-toolbar-title class="toolbar-title"
                        ><v-icon left small>mdi-clipboard-list-outline</v-icon>
                        ระบบสมัครสอบ (2)</v-toolbar-title
                      >
                    </v-toolbar>
                    <v-list class="elegant-list">
                      <v-list-item
                        v-for="(item, i) in appoint_director2"
                        :key="i"
                        :to="item.to"
                        class="elegant-list-item"
                      >
                        <v-list-item-icon
                          ><v-icon
                            v-text="item.icon"
                            class="list-icon"
                            color="green darken-4"
                          ></v-icon
                        ></v-list-item-icon>
                        <v-list-item-content
                          ><v-list-item-title
                            v-text="item.text"
                            class="list-title"
                          ></v-list-item-title
                        ></v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
              </v-row>

              <!-- === ศึกษานิเทศก์ === -->
              <v-alert
                text
                color="deep-orange darken-1"
                icon="mdi-book-education"
                border="left"
                class="mb-4 mt-6 section-header orange-dark-header"
              >
                <h2 class="section-title">
                  คัดเลือก ตำแหน่ง
                  <v-chip
                    small
                    color="white"
                    text-color="deep-orange darken-1"
                    class="ml-2 font-weight-bold"
                    >ศึกษานิเทศก์</v-chip
                  >
                </h2>
              </v-alert>
              <v-row>
                <v-col cols="12" md="6">
                  <v-card tile outlined class="elegant-section-card">
                    <v-toolbar
                      color="deep-orange darken-1"
                      dark
                      class="section-toolbar"
                      dense
                    >
                      <v-toolbar-title class="toolbar-title"
                        ><v-icon left small>mdi-clipboard-list</v-icon>
                        ระบบสมัครสอบ</v-toolbar-title
                      >
                    </v-toolbar>
                    <v-list class="elegant-list">
                      <v-list-item
                        v-for="(item, i) in appoint_supervisor"
                        :key="i"
                        :to="item.to"
                        class="elegant-list-item"
                      >
                        <v-list-item-icon
                          ><v-icon
                            v-text="item.icon"
                            class="list-icon"
                            color="deep-orange darken-1"
                          ></v-icon
                        ></v-list-item-icon>
                        <v-list-item-content
                          ><v-list-item-title
                            v-text="item.text"
                            class="list-title"
                          ></v-list-item-title
                        ></v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
                <v-col cols="12" md="6">
                  <v-card tile outlined class="elegant-section-card">
                    <v-toolbar
                      color="deep-orange darken-1"
                      dark
                      class="section-toolbar"
                      dense
                    >
                      <v-toolbar-title class="toolbar-title"
                        ><v-icon left small>mdi-clipboard-list-outline</v-icon>
                        ผลการคัดเลือก / รายงานตัว</v-toolbar-title
                      >
                    </v-toolbar>
                    <v-list class="elegant-list">
                      <v-list-item
                        v-for="(item, i) in appoint_supervisor2"
                        :key="i"
                        :to="item.to"
                        class="elegant-list-item"
                      >
                        <v-list-item-icon
                          ><v-icon
                            v-text="item.icon"
                            class="list-icon"
                            color="deep-orange darken-1"
                          ></v-icon
                        ></v-list-item-icon>
                        <v-list-item-content
                          ><v-list-item-title
                            v-text="item.text"
                            class="list-title"
                          ></v-list-item-title
                        ></v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
              </v-row>
            </div>

            <!-- ========================================== -->
            <!-- TAB: ครูผู้ช่วย -->
            <!-- ========================================== -->
            <div v-if="tab.id === 'assistant'">
              <v-alert
                text
                color="amber darken-2"
                icon="mdi-school"
                border="left"
                class="mb-4 section-header amber-header"
              >
                <h2 class="section-title">ครูผู้ช่วย</h2>
              </v-alert>
              <v-row>
                <v-col cols="12" md="6">
                  <v-card tile outlined class="elegant-section-card">
                    <v-toolbar
                      color="amber darken-2"
                      dark
                      class="section-toolbar"
                      dense
                    >
                      <v-toolbar-title class="toolbar-title"
                        ><v-icon left small>mdi-account-arrow-right</v-icon>
                        เรียกรายงานตัวครูผู้ช่วย</v-toolbar-title
                      >
                    </v-toolbar>
                    <v-list class="elegant-list">
                      <v-list-item
                        v-for="(item, i) in prepare_items"
                        :key="i"
                        :to="item.to"
                        class="elegant-list-item"
                      >
                        <v-list-item-icon
                          ><v-icon
                            v-text="item.icon"
                            class="list-icon"
                            color="amber darken-2"
                          ></v-icon
                        ></v-list-item-icon>
                        <v-list-item-content
                          ><v-list-item-title
                            v-text="item.text"
                            class="list-title"
                          ></v-list-item-title
                        ></v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
                <v-col cols="12" md="6">
                  <v-card tile outlined class="elegant-section-card">
                    <v-toolbar
                      color="amber darken-2"
                      dark
                      class="section-toolbar"
                      dense
                    >
                      <v-toolbar-title class="toolbar-title"
                        ><v-icon left small>mdi-clipboard-check</v-icon>
                        ระบบประเมินครูผู้ช่วย</v-toolbar-title
                      >
                    </v-toolbar>
                    <v-list class="elegant-list">
                      <v-list-item
                        v-for="(item, i) in prepare_items_committee"
                        :key="i"
                        :to="item.to"
                        class="elegant-list-item"
                      >
                        <v-list-item-icon
                          ><v-icon
                            v-text="item.icon"
                            class="list-icon"
                            color="amber darken-2"
                          ></v-icon
                        ></v-list-item-icon>
                        <v-list-item-content
                          ><v-list-item-title
                            v-text="item.text"
                            class="list-title"
                          ></v-list-item-title
                        ></v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
              </v-row>
            </div>

            <!-- ========================================== -->
            <!-- TAB: ข่าวสาร -->
            <!-- ========================================== -->
            <div v-if="tab.id === 'news'">
              <v-alert
                text
                color="brown darken-1"
                icon="mdi-book-open-page-variant"
                border="left"
                class="mb-4 section-header brown-header"
              >
                <h2 class="section-title">ข่าวสารและคู่มือระบบ</h2>
              </v-alert>
              <v-row>
                <v-col cols="12">
                  <v-card tile outlined class="elegant-section-card">
                    <v-row class="ma-0">
                      <v-col
                        cols="12"
                        md="6"
                        v-for="(item, i) in news_manual"
                        :key="i"
                        class="pa-1"
                      >
                        <v-list class="elegant-list py-0">
                          <v-list-item :to="item.to" class="elegant-list-item">
                            <v-list-item-icon>
                              <v-icon
                                v-text="item.icon"
                                class="list-icon"
                                color="brown darken-1"
                              ></v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title
                                v-text="item.text"
                                class="list-title"
                              ></v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </div>
    </v-card>

    <!-- ========================================== -->
    <!-- Dialog: แก้ไขรหัสผ่าน -->
    <!-- ========================================== -->
    <v-layout row justify-center>
      <v-dialog v-model="edituserdialog" persistent max-width="80%">
        <v-card class="mx-auto pa-6 elegant-dialog" elevation="2">
          <base-material-card
            color="yellow"
            icon="mdi-clipboard-text"
            title="เปลี่ยนรหัสผ่าน"
            class="px-5 py-3 text_google dialog-header"
            elevation="2"
          ></base-material-card>
          <v-card-text class="dialog-content">
            <v-form ref="edituserform" lazy-validation>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex md12>
                    <div class="user-info">
                      {{ edituser.user_name }}
                      {{ edituser.user_firstname }}{{ edituser.user_lastname }}
                    </div>
                  </v-flex>
                  <v-flex md6>
                    <v-text-field
                      outlined
                      label="Password"
                      v-model="edituser.user_password"
                      type="password"
                      class="elegant-input"
                    ></v-text-field>
                  </v-flex>
                  <v-flex md6>
                    <v-text-field
                      outlined
                      label="Confirm Password"
                      v-model="edituser.user_confirmpassword"
                      type="password"
                      required
                      :rules="[v => v == edituser.user_password]"
                      class="elegant-input"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-divider class="elegant-divider"></v-divider>
                  </v-flex>
                </v-layout>
              </v-container>
              <small class="required-text">* จำเป็น</small>
            </v-form>
          </v-card-text>
          <v-card-actions class="dialog-actions">
            <v-spacer></v-spacer>
            <v-btn
              large
              @click.stop="edituserdialog = false"
              rounded
              class="cancel-btn"
            >
              <v-icon dark left>mdi-close</v-icon>ยกเลิก
            </v-btn>
            <v-btn
              large
              color="amber lighten-1"
              @click.stop="edituserSubmit()"
              rounded
              class="submit-btn"
            >
              <v-icon dark left>mdi-pencil</v-icon>แก้ไข
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <!-- ========================================== -->
    <!-- Dialog: ยกเลิกกำหนดการ -->
    <!-- ========================================== -->
    <v-layout row justify-center>
      <v-dialog v-model="endCalendardialog" persistent max-width="50%">
        <v-card class="mx-auto pa-6 elegant-dialog" elevation="2">
          <base-material-card
            color="warning"
            icon="mdi-clipboard-text"
            title="ยกเลิกกำหนดการระบบทั้งหมด"
            class="px-5 py-3 text_google dialog-header"
            elevation="2"
          ></base-material-card>
          <v-card-text class="dialog-content">
            <v-form ref="endCalendarform" lazy-validation>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex md12>
                    <v-text-field
                      outlined
                      label="Confirm Password"
                      v-model="confirmPassword"
                      required
                      :rules="[v => v == 'Th07111988@7']"
                      :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="show1 ? 'text' : 'password'"
                      hint="At least 12 characters"
                      counter
                      @click:append="show1 = !show1"
                      class="elegant-input"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-divider class="elegant-divider"></v-divider>
                  </v-flex>
                </v-layout>
              </v-container>
              <small class="required-text">* จำเป็น</small>
            </v-form>
          </v-card-text>
          <v-card-actions class="dialog-actions">
            <v-spacer></v-spacer>
            <v-btn
              color="success"
              @click.stop="endCalendarSubmit()"
              rounded
              class="confirm-btn"
            >
              <v-icon dark left>mdi-checkbox-marked-circle-outline</v-icon
              >ยืนยัน
            </v-btn>
            <v-btn
              fab
              small
              @click.stop="endCalendardialog = false"
              rounded
              class="close-btn"
            >
              <v-icon dark>mdi-close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-container fluid>
      <v-snackbar
        v-model="snackbar.show"
        top
        :timeout="snackbar.timeout"
        :color="snackbar.color"
        class="elegant-snackbar"
      >
        <v-icon large left>{{ snackbar.icon }}</v-icon>
        {{ snackbar.text }}
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar.show = false"
            >Close</v-btn
          >
        </template>
      </v-snackbar>
    </v-container>
  </v-container>
</template>

<script>
import AlertAssistant_teacher from "../../components/admin/alertAssistant_teacher.vue";
import AlertAssistant_teacher2 from "../../components/admin/alertAssistant_teacher2.vue";
import AlertAssistant_teacher3_licence from "../../components/admin/alertAssistant_teacher3_licence.vue";

export default {
  components: {
    AlertAssistant_teacher,
    AlertAssistant_teacher2,
    AlertAssistant_teacher3_licence
  },
  data() {
    return {
      activeTab: 0,
      ApiKey: "HRvec2021",
      user: {},
      users: [],
      edituser: [],
      edituserdialog: false,
      snackbar: {
        show: false,
        color: "",
        timeout: 5000,
        icon: "",
        text: ""
      },

      // === ข้อมูลพื้นฐาน ===
      user_system_items: [
        {
          text: "ข้อมูลผู้ใช้งานระบบ ข้าราชการครูและบุคลาการทางการศึกษา",
          icon: "mdi-account-arrow-right",
          to: "/admin/personnel"
        },
        {
          text: "ข้อมูลผู้ใช้งานระบบ วิทยาลัย สอจ.สถานบัน กจ2 Admin",
          icon: "mdi-account-arrow-right",
          to: "/admin/user"
        },
        {
          text: "สถานะผู้ใช้งานระบบ",
          icon: "mdi-account-cog",
          to: "/admin/user_status"
        }
      ],
      college_items: [
        {
          text: "ข้อมูลประเภทสถานศึกษา",
          icon: "mdi-office-building",
          to: "/admin/collegetype"
        },
        {
          text: "ข้อมูลสถาบันการอาชีวศึกษา",
          icon: "mdi-office-building",
          to: "/admin/veivocal"
        },
        {
          text: "ข้อมูลสถานศึกษา",
          icon: "mdi-office-building",
          to: "/admin/college"
        },
        {
          text: "ข้อมูลรายละเอียดสถานศึกษา",
          icon: "mdi-office-building",
          to: "/admin/collegeinfo"
        }
      ],
      user_items: [
        {
          text: "จัดการคำนำหน้าชื่อ",
          icon: "mdi-format-title",
          to: "/admin/prefix"
        },
        {
          text: "ข้าราชการครูและบุคลากร (หลัก)",
          icon: "mdi-account",
          to: "/admin/personnel_tem"
        },
        {
          text: "บุคลากร งานอัตรากำลัง (รอง)",
          icon: "mdi-account",
          to: "/admin/personnel_etc"
        },
        {
          text: "ข้อมูลขอรับข้อมูลบุคคล",
          icon: "mdi-account-convert",
          to: "/admin/collegepersonnelreq"
        },
        {
          text: "ข้อมูลคุณวุฒิการศึกษา",
          icon: "mdi-school",
          to: "/admin/personnel_education"
        },
        {
          text: "ข้อมูลประสบการณ์",
          icon: "mdi-airplane",
          to: "/admin/personnel_experience"
        },
        {
          text: "ข้อมูลประวัติการรับราชการ",
          icon: "mdi-access-point-network",
          to: "/admin/personnel_work_history"
        },
        {
          text: "ข้อมูลผลงาน รางวัล",
          icon: "mdi-trophy-award",
          to: "/admin/personnel_award"
        },
        {
          text: "จัดการข้อมูลคุณวุฒิระดับการศึกษา",
          icon: "mdi-trophy-award",
          to: "/admin/cls_degree"
        }
      ],
      about_brach: [
        {
          text: "สาขาวิชาเอก งานย้ายสายการสอน",
          icon: "mdi-source-branch",
          to: "/admin/branch"
        },
        {
          text: "สาขางาน งานย้ายสายการสอน",
          icon: "mdi-source-branch",
          to: "/admin/branch_sub"
        },
        {
          text: "ประเภทวิชา",
          icon: "mdi-source-branch",
          to: "/admin/subject_type"
        },
        {
          text: "สาขาวิชา/สาขางาน",
          icon: "mdi-source-branch",
          to: "/admin/rate_work_course_std"
        },
        {
          text: "หลักสูตรวิชาชีพระยะสั้น",
          icon: "mdi-source-branch",
          to: "/admin/short_course"
        }
      ],

      // === งานอัตรากำลัง ===
      human_items: [
        {
          text: "กำหนดการ รายงานอัตรากำลัง",
          icon: "mdi-calendar",
          to: "/admin/sys_config_collegemanpower"
        },
        {
          text: "อัตรากำลังสถานศึกษา",
          icon: "mdi-account-multiple",
          to: "/admin/personnel_etc"
        },
        {
          text: "ข้อมูลลูกจ้างชั่วคราว",
          icon: "mdi-account-multiple",
          to: "/admin/personnel_etc_tem"
        },
        {
          text: "รายงานอัตรากำลังประจำปี สถานศึกษา",
          icon: "mdi-account-multiple",
          to: "/admin/rate_work_g"
        },
        {
          text: "จำนวนนักเรียน ศธ.02",
          icon: "mdi-account-multiple",
          to: "/admin/power_rate/rate_work_college"
        }
      ],
      manpower_move: [
        {
          text: "ข้อมูลอัตรากำลังสถานศึกษา สำหรับย้าย",
          icon: "mdi-account-multiple",
          to: "/admin/man_power"
        },
        {
          text: "ข้อมูลอัตรากำลัง จ.18",
          icon: "mdi-account-multiple",
          to: "/admin/jor18"
        }
      ],
      humanreport_items: [
        {
          text: "กำหนดการ",
          icon: "mdi-calendar",
          to: "/admin/sys_config_collegemanpower_report"
        },
        {
          text: "จัดการเลขที่ตำแหน่งว่าง",
          icon: "mdi-account-multiple",
          to: "/admin/jor18"
        },
        {
          text: "สถานะการรายงาน",
          icon: "mdi-account-multiple",
          to: "/admin/jor18_report"
        },
        {
          text: "การรายงาน (เลขที่ตำแหน่ง)",
          icon: "mdi-account-multiple",
          to: "/admin/college_manpower"
        }
      ],

      // === ย้าย 38 ค.(2) ===
      movement38_items: [
        {
          text: "กำหนดการย้าย 38 ค.(2)",
          icon: "mdi-calendar",
          to: "/admin/timelines/transfer_38"
        },
        {
          text: "ตำแหน่งว่าง",
          icon: "mdi-calendar",
          to: "/admin/man_power_38"
        },
        {
          text: "ย้าย 38 ค.(2)",
          icon: "mdi-calculator",
          to: "/admin/transference_personnel_38"
        }
      ],

      // === ย้ายสายการสอน ===
      movement_items: [
        {
          text: "กำหนดการย้ายครู",
          icon: "mdi-calendar",
          to: "/admin/timelines/transfer_teachers"
        },
        {
          text: "ย้ายครู ประกอบการพิจารณา",
          icon: "mdi-account-switch",
          to: "/admin/transference_location_detail"
        },
        {
          text: "ย้ายครู รายละเอียด",
          icon: "mdi-account-switch",
          to: "/admin/transference_location"
        },
        {
          text: "ย้ายครู [ประมวลผลแบบ 1]",
          icon: "mdi-calculator",
          to: "/admin/transference_personnel"
        },
        {
          text: "ย้ายครู [กรณีพิเศษ]",
          icon: "mdi-calculator",
          to: "/admin/transference_personnel_sp"
        },
        {
          text: "ประมวลผลการย้าย [แบบ 2]",
          icon: "mdi-calculator",
          to: "/admin/process_transfer"
        },
        {
          text: "ประมวลผลการย้าย สับเปลี่ยนปกติ [แบบ 3]",
          icon: "mdi-calculator",
          to: "/admin/process_transfer_switch_normal"
        },
        {
          text: "ประมวลผลการย้าย [แบบ 4 สับเปลี่ยน]",
          icon: "mdi-calculator",
          to: "/admin/process_transfer_switch"
        },
        {
          text: "สรุปผลการย้าย",
          icon: "mdi-newspaper",
          to: "/admin/conditons_transfer_success"
        },
        {
          text: "การรายงานตัว ณ วิทยาลัย",
          icon: "mdi-calculator",
          to: "/admin/conditons_transfer_success_reportmv"
        }
      ],
      condition_items: [
        {
          text: "เงือนไขการรับย้ายของสถานศึกษา",
          icon: "mdi-checkbox-multiple-marked-outline",
          to: "/admin/conditions_transfer"
        },
        {
          text: "เงือนไขการรับย้ายสาขาวิชา",
          icon: "mdi-checkbox-multiple-marked-outline",
          to: "/admin/conditions_branch"
        }
      ],
      commiteevecpro: [
        {
          text: "รายงานคณะกรรมการ สอจ.",
          icon: "mdi-checkbox-multiple-marked-outline",
          to: "/admin/commiteevecreport"
        },
        {
          text: "รายชื่อกรรมการ สอจ.",
          icon: "mdi-checkbox-multiple-marked-outline",
          to: "/admin/commiteevecpro"
        }
      ],
      official_book: [
        {
          text: "คำสั่งแต่งตั้งรักษาการในตำแหน่ง",
          icon: "mdi-bookmark-check",
          to: "/admin/Order_appoint"
        },
        {
          text: "ศูนย์กลางส่งออกเอกสาร ประกอบการพิจารณาย้าย",
          icon: "mdi-bookmark-check",
          to: "/admin/transference_export_report"
        }
      ],

      // === ย้ายสายบริหาร ===
      movement_manage_items: [
        {
          text: "กำหนดการ ย้ายสายบริหาร",
          icon: "mdi-calendar",
          to: "/admin/timelines/transfer_directors"
        },
        {
          text: "สายงานบริหารสถานศึกษา",
          icon: "mdi-account-switch",
          to: "/admin/transference_manage_main"
        },
        {
          text: "ประกอบการพิจารณา",
          icon: "mdi-account-switch",
          to: "/admin/transference_manage_location_detail"
        },
        {
          text: "รายละเอียด",
          icon: "mdi-account-switch",
          to: "/admin/transference_manage_location"
        },
        {
          text: "[ประมวลผลแบบ 1]",
          icon: "mdi-calculator",
          to: "/admin/transference_manage"
        }
      ],

      // === พนักงานราชการ ===
      movement_govem_manpoweritems: [
        {
          text: "กำหนดการรายงานข้อมูลกรอบอัตรากำลัง",
          icon: "mdi-numeric-1-box",
          to: "/admin/gov_em/period_mgovem"
        },
        {
          text: "การรายงานกรอบอัตรากำลังของสถานศึกษา",
          icon: "mdi-numeric-2-box",
          to: "/admin/gov_em/Governmentemployeereportadmin"
        },
        
         {
          text: "กรอบอัตรากำลัง พนักงานราชการ ส่วนกลาง",
          icon: "mdi-numeric-3-box",
          to: "/admin/gov_em_vec/government_employee"
        },
        {
          text: "ข้อมูล กรอบอัตรากำลัง",
          icon: "mdi-numeric-4-box",
          to: "/admin/gov_em/government_employee"
        },
         {
          text: "รายงาน กรอบอัตรากำลัง พนักงานราชการ",
          icon: "mdi-numeric-5-box",
          to: "/admin/gov_em/government_employee_report"
        },

         {
          text: "รายงาน ข้อมูลการเบิกจ่ายงบประมาณ สนผ.",
          icon: "mdi-numeric-6-box",
          to: "/admin/government_employee_report_snp"
        }
      ],
      govem_manpowerManageitems: [      
        { text: "ประวัติการประเมินผลการปฏิบัติงาน", icon: "mdi-numeric-7-box",to: "/admin/gov_em/admin_assessment_report" },
        {
          text: "ประวัติการลาออก",
          icon: "mdi-numeric-8-box",
          to: "/admin/gov_em/ResignHistoryPage"
        }
      ],
      movement_govem_manpowerSalaryitems: [
        {
          text: "คำตอบแทน ปี พ.ศ. 2568",
          icon: "mdi-numeric-9-box",
          to: "/admin/gov_em/salary_gov_2568"
        }
      ],
      movement_govem_items: [
        {
          text: "กำหนดการย้าย พนักงานราชการ",
          icon: "mdi-calendar",
          to: "/admin/timelines/transfer_govem"
        },
        {
          text: "ย้ายพนักงานราชการ ประกอบการพิจารณา",
          icon: "mdi-account-switch",
          to: "/admin/gov_em/transference_location_detail"
        },
        {
          text: "ย้ายพนักงานราชการ รายละเอียด",
          icon: "mdi-account-switch",
          to: "/admin/gov_em/transference_location"
        },
        {
          text: "ประมวลผลการย้าย [แบบ 1]",
          icon: "mdi-calculator",
          to: "/admin/gov_em/transference_personnel"
        },
        {
          text: "ประมวลผลการย้าย [แบบ 2]",
          icon: "mdi-calculator",
          to: "/admin/gov_em/process_transfer"
        },
        {
          text: "ประมวลผลการย้าย สับเปลี่ยนปกติ [แบบ 3]",
          icon: "mdi-calculator",
          to: "/admin/gov_em/process_transfer_switch_normal"
        },
        {
          text: "ประมวลผลการย้าย [แบบ 4 สับเปลี่ยน]",
          icon: "mdi-calculator",
          to: "/admin/gov_em/process_transfer_switch"
        },
        {
          text: "สรุปผลการย้าย",
          icon: "mdi-newspaper",
          to: "/admin/gov_em/conditons_transfer_success"
        }
      ],
      condition_govem_items: [
        {
          text: "ข้อมูลอัตรา พนักงานราชการ",
          icon: "mdi-checkbox-multiple-marked-outline",
          to: "/admin/man_power_govem"
        },
        {
          text: "รายงานตำแหน่งว่าง ของส่วนกลาง",
          icon: "mdi-checkbox-multiple-marked-outline",
          to: "/admin/conditions_branch_govem"
        },
        {
          text: "รายงานตำแหน่งว่าง ของสถานศึกษา",
          icon: "mdi-checkbox-multiple-marked-outline",
          to: "/admin/government_employee_report"
        },
        {
          text: "รายงานตำแหน่งว่าง รายละเอียด",
          icon: "mdi-checkbox-multiple-marked-outline",
          to: "/admin/college_manpower_govem"
        }
      ],
      official_book_govem: [
        {
          text: "คำสั่งย้าย",
          icon: "mdi-bookmark-check",
          to: "/admin/gov_em/Order_appoint"
        },
        {
          text: "การรายงานตัว ปลายทาง",
          icon: "mdi-calculator",
          to: "/admin/gov_em/conditons_transfer_success_reportmv"
        }
      ],

      // === คัดเลือก รองผู้อำนวยการ ===
      appoint_sedirector: [
        {
          text: "กำหนดการ คัดเลือก รอง ผอ.",
          icon: "mdi-calendar-clock",
          to: "/admin/timelines/examination_deputyDirector"
        },
        {
          text: "ผู้สมัคร",
          icon: "mdi-account-edit",
          to: "/admin/sedirector_app"
        },
        {
          text: "ภาค ก.",
          icon: "mdi-file-document-edit",
          to: "/admin/sedirector_assessment/sedirector_app_a"
        },
        {
          text: "ภาค ข.",
          icon: "mdi-file-document-edit-outline",
          to: "/admin/sedirector_assessment/sedirector_app_b"
        },
        {
          text: "ประกาศผล",
          icon: "mdi-bullhorn",
          to: "/admin/sedirector_assessment/sedirector_app_notice"
        }
      ],
      appoint_sedirector2: [
        {
          text: "ตำแหน่งว่างสถานศึกษา",
          icon: "mdi-domain",
          to: "/admin/sedirector_assessment/director_college_manpower"
        },
        {
          text: "รายงานตัวเลือกสถานศึกษา",
          icon: "mdi-account-arrow-right",
          to: "/admin/sedirector_assessment/sedirector_app_choose"
        },
        {
          text: "รายงาน ณ สถานศึกษา",
          icon: "mdi-home-account",
          to: "/admin/sedirector_assessment/sedirector_app_a"
        }
      ],

      // === คัดเลือก ผู้อำนวยการ ===
      appoint_director: [
        {
          text: "กำหนดการ คัดเลือก ผอ.",
          icon: "mdi-calendar-clock",
          to: "/admin/timelines/examination_Director"
        },
        {
          text: "ผู้สมัคร",
          icon: "mdi-account-edit",
          to: "/admin/director_app"
        },
        {
          text: "ภาค ก.",
          icon: "mdi-file-document-edit",
          to: "/admin/director_assessment/director_app_a"
        },
        {
          text: "ภาค ข.",
          icon: "mdi-file-document-edit-outline",
          to: "/admin/director_assessment/director_app_b"
        },
        {
          text: "ภาค ค.",
          icon: "mdi-file-certificate",
          to: "/admin/director_assessment/director_app_c"
        },
        {
          text: "ประกาศผล",
          icon: "mdi-bullhorn",
          to: "/admin/director_assessment/director_app_notice"
        }
      ],
      appoint_director2: [
        {
          text: "ตำแหน่งว่างสถานศึกษา",
          icon: "mdi-domain",
          to: "/admin/director_assessment/director_college_manpower"
        },
        {
          text: "รายงานตัวเลือกสถานศึกษา",
          icon: "mdi-account-arrow-right",
          to: "/admin/director_assessment/director_app_choose"
        },
        {
          text: "รายงาน ณ สถานศึกษา",
          icon: "mdi-home-account",
          to: "/admin/director_assessment/director_app_report_college"
        }
      ],

      // === คัดเลือก ศึกษานิเทศก์ (ใหม่) ===
      appoint_supervisor: [
        {
          text: "กำหนดการ คัดเลือก ศึกษานิเทศก์",
          icon: "mdi-calendar-clock",
          to: "/admin/timelines/examination_Supervisor"
        },
        {
          text: "ผู้สมัคร",
          icon: "mdi-account-edit",
          to: "/admin/supervisor_app"
        },      
      ],
      appoint_supervisor2: [
        {
          text: "ประกาศรายชื่อผู้ผ่านการคัดเลือก",
          icon: "mdi-clipboard-list",
          to: "/admin/supervisor_assessment/supervisor_app_passed"
        },
        {
          text: "รายงานตัว / บรรจุแต่งตั้ง",
          icon: "mdi-home-account",
          to: "/admin/supervisor_assessment/supervisor_app_report"
        }
      ],

      // === ครูผู้ช่วย ===
      prepare_items: [
        {
          text: "กำหนดการ ครูผู้ช่วย",
          icon: "mdi-calendar",
          to: "/admin/timelines/report_assistantteacher"
        },
        {
          text: "เรียกรายงานตัวครูผู้ช่วย/รอบ",
          icon: "mdi-account-settings",
          to: "/admin/assistant_teacher_report/manage_assistant_teacher"
        },
        {
          text: "ข้อมูลเลขที่ตำแหน่ง วิทยาลัย",
          icon: "mdi-account-settings",
          to: "/admin/assistant_teacher_report/manage_college_manpower"
        },
        {
          text: "การรายงานตัวเลือกสถานศึกษา",
          icon: "mdi-account-star",
          to: "/admin/assistant_teacher_report/teacher_college_manpower_report"
        },
        {
          text: "การรายงานตัว ณ สถานศึกษา",
          icon: "mdi-account-star",
          to: "/admin/assistant_teacher_report/manage_assistant_CollegeReport"
        },
        {
          text: "การรายงานตัว ณ สถานศึกษา(โอนย้าย)",
          icon: "mdi-account-star",
          to:
            "/admin/assistant_teacher_report/manage_assistant_CollegeReportTran"
        }
      ],
      prepare_items_committee: [
        {
          text: "รอบบรรจุ",
          icon: "mdi-calendar",
          to:
            "/admin/assistant_teacher_report/personnel_temporary_assistant_period"
        },
        {
          text: "เสนอผู้ทรงคุณวุฒิ",
          icon: "mdi-account-settings",
          to: "/admin/assistant_teacher_report/assistantcommitteequalified"
        },
        {
          text: "เสนอคณะกรรมการ",
          icon: "mdi-account-settings",
          to:
            "/admin/assistant_teacher_report/manage_assistant_teacher_committee"
        },
        {
          text: "การประเมิน/ตรวจสอบ",
          icon: "mdi-account-star",
          to: "/admin/assistant_teacher"
        },
        {
          text: "รายงานผลประเมิน(ครบ)",
          icon: "mdi-account-star",
          to: "/admin/assistant_teacher_reports"
        },
        {
          text: "ข้อมูลเอกสารแนบ",
          icon: "mdi-account-star",
          to: "/admin/assistant_teacher_report/manage_assistant_teacher_doc"
        },
        {
          text: "ครูผู้ช่วย",
          icon: "mdi-account-star",
          to: "/admin/manage_assistant_teacher_data"
        }
      ],

      // === ข่าวสาร ===
      news_manual: [
        { text: "ข่าวสาร", icon: "mdi-book", to: "/admin/news_s" },
        {
          text: "คู่มือใช้งาน",
          icon: "mdi-book-open-page-variant",
          to: "/admin/manual_s"
        }
      ],

      endCalendardialog: false,
      confirmPassword: "",
      show1: false,
      updateSystems: {}
    };
  },

  async mounted() {
    await this.userQueryAll();
  },

  computed: {
    filteredUserItems() {
      if (this.user.userauthority_govem === "1") {
        return this.user_items.filter(
          item =>
            item.to !== "/admin/personnel_etc" &&
            item.to !== "/admin/collegepersonnelreq"
        );
      }
      return this.user_items;
    },
    availableTabs() {
      const tabs = [];
      const u = this.user;

      if (u.userauthorityAdmin === "1" || u.userauthority_govem === "1") {
        tabs.push({
          id: "basic",
          title: "ข้อมูลพื้นฐาน",
          icon: "mdi-database",
          color: "teal darken-1"
        });
      }
      if (u.userauthorityManpower === "1") {
        tabs.push({
          id: "manpower",
          title: "งานอัตรากำลัง",
          icon: "mdi-account-group",
          color: "blue darken-1"
        });
      }
      if (
        u.userauthorityMoveTeach === "1" ||
        u.userauthorityMoveManage === "1"
      ) {
        tabs.push({
          id: "transfer",
          title: "ย้ายข้าราชการ/บริหาร",
          icon: "mdi-swap-horizontal",
          color: "pink darken-1"
        });
      }
      if (u.userauthority_govem === "1") {
        tabs.push({
          id: "govem",
          title: "พนักงานราชการ",
          icon: "mdi-account-tie",
          color: "indigo"
        });
      }
      if (u.userauthorityAssessSedirector === "1") {
        tabs.push({
          id: "selection",
          title: "คัดเลือกสายบริหาร/ศน.",
          icon: "mdi-star-circle",
          color: "green darken-1"
        });
      }
      if (u.userauthorityAssitantTeach === "1") {
        tabs.push({
          id: "assistant",
          title: "ครูผู้ช่วย",
          icon: "mdi-school",
          color: "amber darken-2"
        });
      }

      tabs.push({
        id: "news",
        title: "ข่าวสารและคู่มือ",
        icon: "mdi-book-open-page-variant",
        color: "brown darken-1"
      });

      return tabs;
    }
  },

  methods: {
    async clearUpdate() {
      Swal.fire({
        title: "Reset For Update",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ดำเนินการ",
        cancelButtonText: "ยกเลิก"
      }).then(async result => {
        if (result.isConfirmed) {
          let res = await this.$http.post("user.reset.update.php", {
            ApiKey: this.ApiKey
          });
          if (res.data.status == true) {
            Swal.fire({
              icon: "success",
              title: "ดำเนินการเรียบร้อย",
              showConfirmButton: false,
              timer: 1500
            });
          } else {
            Swal.fire({
              icon: "warning",
              title: "ดำเนินการซ้ำ",
              showConfirmButton: false,
              timer: 1500
            });
          }
        }
      });
    },
    async endCalendarSubmit() {
      if (this.$refs.endCalendarform.validate()) {
        this.updateSystems.ApiKey = this.ApiKey;
        let result = await this.$http.post(
          "period.update.allsystem.php",
          this.updateSystems
        );
        if (result.data.status == true) {
          Swal.fire({
            icon: "success",
            title: "ดำเนินการปิดกำหนดการในระบบเรียบร้อย",
            showConfirmButton: false,
            timer: 1500
          });
        } else {
          Swal.fire({
            icon: "warning",
            title: "ดำเนินการผิดพลาด",
            showConfirmButton: false,
            timer: 1500
          });
        }
      }
    },
    async endCalendar() {
      this.endCalendardialog = true;
    },
    async userQueryAll() {
      let userSession = JSON.parse(sessionStorage.getItem("user")) || 0;
      let result = await this.$http.post("user.php", {
        ApiKey: this.ApiKey,
        user_ID: userSession.user_ID
      });
      this.user = result.data;
    },
    async userUpdate() {
      let result = await this.$http.post("user.php", {
        ApiKey: this.ApiKey,
        user_ID: this.user.user_ID
      });
      this.edituser = result.data;
      this.edituser.p_word = "";
      this.edituserdialog = true;
    },
    async edituserSubmit() {
      if (this.$refs.edituserform.validate()) {
        this.edituser.ApiKey = this.ApiKey;
        let result = await this.$http.post("user.update.php", this.edituser);
        if (result.data.status == true) {
          this.user = result.data;
          Swal.fire({
            icon: "success",
            title: "ดำเนินการแก้ไขข้อมูลเรียบร้อย",
            showConfirmButton: false,
            timer: 1500
          });
          this.userQueryAll();
        } else {
          Swal.fire({
            icon: "warning",
            title: "ดำเนินการผิดพลาด",
            showConfirmButton: false,
            timer: 1500
          });
        }
        this.edituserdialog = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
/* === Main Container === */
.elegant-container {
  background: linear-gradient(160deg, #f0f4f8 0%, #ffffff 50%, #f8fafb 100%);
  min-height: 100vh;
  padding: 24px;
  font-family: "Sarabun", "Noto Sans Thai", sans-serif;
}

/* === User Card === */
.elegant-user-card {
  background: rgba(255, 255, 255, 0.97) !important;
  border-radius: 14px !important;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06) !important;
  border: 1px solid rgba(0, 0, 0, 0.04) !important;
  padding: 24px !important;
  transition: all 0.3s ease;
}

.user-title {
  color: #1a202c;
  font-weight: 700;
  font-size: 1.35rem;
  margin-bottom: 6px;
}
.user-name {
  color: #4a5568;
  font-weight: 500;
  font-size: 1.1rem;
  margin-bottom: 4px;
}
.user-status {
  color: #718096;
  font-weight: 400;
  font-size: 1rem;
}

/* === Main Card & Tabs === */
.elegant-main-card {
  background: #ffffff !important;
  border-radius: 14px !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.07) !important;
  border: 1px solid rgba(0, 0, 0, 0.04) !important;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.d-flex.flex-column.flex-md-row {
  align-items: flex-start;
}

.elegant-tabs-menu {
  border-right: 1px solid #e8ecf1;
  min-width: 250px !important;
  max-width: 250px !important;
  flex: 0 0 250px !important;
  background: #f7f9fb !important;
}

.elegant-tab-content {
  width: calc(100% - 250px);
  flex: 1 1 auto;
  min-width: 0;
}

.tab-item {
  text-transform: none !important;
  font-size: 0.92rem !important;
  font-weight: 500;
  letter-spacing: 0;
  transition: all 0.25s ease;
  border-radius: 0 20px 20px 0 !important;
  margin-right: 12px !important;
  margin-top: 3px !important;
  margin-bottom: 3px !important;
  justify-content: flex-start;
  width: 100%;
  min-height: 48px !important;
}

.tab-title {
  white-space: pre-wrap;
  text-align: left;
  line-height: 1.35;
}

.active-tab {
  background: linear-gradient(
    135deg,
    rgba(13, 148, 136, 0.08) 0%,
    rgba(20, 184, 166, 0.12) 100%
  ) !important;
  color: #0f766e !important;
  font-weight: 600 !important;
}

/* === Section Cards === */
.elegant-section-card {
  background: #ffffff;
  border-radius: 10px !important;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04) !important;
  border: 1px solid #edf2f7 !important;
  transition: all 0.25s ease;
  height: 100%;
  display: flex;
  flex-direction: column;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.07) !important;
  }
}

.section-toolbar {
  border-radius: 10px 10px 0 0 !important;
  box-shadow: none !important;
}

.toolbar-title {
  font-weight: 600;
  font-size: 0.92rem;
}

/* === Lists === */
.elegant-list {
  background: transparent !important;
  padding: 6px;
  flex-grow: 1;
}

.elegant-list-item {
  border-radius: 8px;
  margin: 1px 0;
  padding: 0 12px;
  min-height: 40px !important;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(0, 0, 0, 0.03) !important;
    transform: translateX(3px);
  }
}

.list-icon {
  font-size: 1.2rem;
  opacity: 0.85;
}

.list-title {
  font-weight: 500;
  font-size: 0.9rem;
  color: #334155;
  line-height: 1.4;
}

/* === Section Alert Headers === */
.section-header {
  border-radius: 10px !important;
  padding: 14px 18px !important;
}

.section-title {
  color: inherit;
  font-weight: 700;
  font-size: 1.15rem;
  margin: 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
}

/* === Color Theme Headers === */
.teal-header {
  background: linear-gradient(
    135deg,
    rgba(13, 148, 136, 0.12) 0%,
    rgba(20, 184, 166, 0.08) 100%
  ) !important;
  color: #0d7377 !important;
}
.blue-header {
  background: linear-gradient(
    135deg,
    rgba(37, 99, 235, 0.12) 0%,
    rgba(59, 130, 246, 0.08) 100%
  ) !important;
  color: #1d4ed8 !important;
}
.red-header {
  background: linear-gradient(
    135deg,
    rgba(220, 38, 38, 0.12) 0%,
    rgba(239, 68, 68, 0.08) 100%
  ) !important;
  color: #dc2626 !important;
}
.pink-header {
  background: linear-gradient(
    135deg,
    rgba(219, 39, 119, 0.12) 0%,
    rgba(236, 72, 153, 0.08) 100%
  ) !important;
  color: #be185d !important;
}
.purple-header {
  background: linear-gradient(
    135deg,
    rgba(124, 58, 237, 0.12) 0%,
    rgba(139, 92, 246, 0.08) 100%
  ) !important;
  color: #6d28d9 !important;
}
.purple-accent-header {
  background: linear-gradient(
    135deg,
    rgba(124, 58, 237, 0.12) 0%,
    rgba(167, 139, 250, 0.08) 100%
  ) !important;
  color: #7c3aed !important;
}
.indigo-header {
  background: linear-gradient(
    135deg,
    rgba(67, 56, 202, 0.12) 0%,
    rgba(99, 102, 241, 0.08) 100%
  ) !important;
  color: #4338ca !important;
}
.green-header {
  background: linear-gradient(
    135deg,
    rgba(22, 163, 74, 0.12) 0%,
    rgba(34, 197, 94, 0.08) 100%
  ) !important;
  color: #15803d !important;
}
.green-dark-header {
  background: linear-gradient(
    135deg,
    rgba(21, 128, 61, 0.14) 0%,
    rgba(22, 101, 52, 0.08) 100%
  ) !important;
  color: #14532d !important;
}
.orange-dark-header {
  background: linear-gradient(
    135deg,
    rgba(234, 88, 12, 0.12) 0%,
    rgba(249, 115, 22, 0.08) 100%
  ) !important;
  color: #c2410c !important;
}
.amber-header {
  background: linear-gradient(
    135deg,
    rgba(217, 119, 6, 0.12) 0%,
    rgba(245, 158, 11, 0.08) 100%
  ) !important;
  color: #b45309 !important;
}
.brown-header {
  background: linear-gradient(
    135deg,
    rgba(120, 53, 15, 0.12) 0%,
    rgba(146, 64, 14, 0.08) 100%
  ) !important;
  color: #78350f !important;
}

/* === Responsive === */
@media (max-width: 959px) {
  .elegant-tabs-menu {
    border-right: none;
    border-bottom: 1px solid #e8ecf1;
    min-width: 100% !important;
    max-width: 100% !important;
    flex: 0 0 auto !important;
  }
  .elegant-tab-content {
    width: 100%;
  }
  .tab-item {
    border-radius: 10px !important;
    margin: 0 3px !important;
  }
}
</style>
